import MAIN_BYNX_LOGO from '../../assets/logos/main_bynx_logo.png';
import DYNAMIC_CUSTOMER_LOGO from '../../assets/logos/greggs_logo.png';
import AUDI_SEDAN_IMAGE from '../../assets/images/audi_sedan.jpg';
import NIGHT_BANNER_IMAGE from '../../assets/images/night_banner_4000.jpg';
import CAR_MAINTENANCE_BONNET_IMAGE from "../../assets/images/hands_in_bonnet.png";
import TYRES_FOR_PURCHASE_IMAGE from "../../assets/images/tyres_on_rack.png";
import CAR_BUMPER_DENT_IMAGE from "../../assets/images/dinged_car_bumper.png";
import GREEN_FOOTPRINT_IMAGE from "../../assets/images/green_footprint.jpg";
import OLD_ODOMETER_IMAGE from "../../assets/images/odometer_old.png";
import ODOMETER_IMAGE from "../../assets/images/odometer.jpg";
import TRAVEL_IMAGE from "../../assets/images/compass.jpg";
import INCIDENT from "../../assets/images/incident.jpeg";
import MAINTENANCE_AND_SERVICING_IMAGE from "../../assets/images/maintenance_and_servicing.png";
import DAMAGE_GUIDANCE from "../../assets/videos/Driver Portal Accident Help Video.mp4";
import TYRE_REPLACEMENT_IMAGE from "../../assets/images/tyre_replacements.png";
import QUOTE_IMAGE from "../../assets/images/quotes.png";


export const imageLocations = Object.freeze({
    /* Bynx Logo */
    MAIN_BYNX_LOGO,

    /* Temp Customer Logo */  //From DB not here
    DYNAMIC_CUSTOMER_LOGO,

    /* Main Images */
    AUDI_SEDAN_IMAGE,

    /* Banner Images */
    NIGHT_BANNER_IMAGE,

    /* Panel Images */
    CAR_MAINTENANCE_BONNET_IMAGE,
    TYRES_FOR_PURCHASE_IMAGE,
    CAR_BUMPER_DENT_IMAGE,
    GREEN_FOOTPRINT_IMAGE,
    OLD_ODOMETER_IMAGE,
    ODOMETER_IMAGE,
    TRAVEL_IMAGE,
    INCIDENT,
    MAINTENANCE_AND_SERVICING_IMAGE,
    DAMAGE_GUIDANCE,
    TYRE_REPLACEMENT_IMAGE,
    QUOTE_IMAGE
});